import { Turbo } from '@hotwired/turbo-rails';
import $ from 'jquery';
import { buildRequestRoutes } from 'packs/shared/routes';
import initApps from '../../lib/initApps';
import EmailOptionApplication from './email_mfa_option';

window.serverClient = buildRequestRoutes();

const allApps = [
  EmailOptionApplication,
  $
];

Turbo.config.forms.mode = 'off';

$(document).on('turbo:load', () => {
  initApps(allApps);
});
